import { Alert, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Divider, FormControl, FormControlLabel, FormGroup, FormHelperText, Grid, TextField } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Close } from '@mui/icons-material';
import LoadingButton from './global-components/loading-btn';
import { getWLProfile, sendAmakknWhatsAppMessage, sendWhatsAppMessage } from '../api/userApi';
import { useAuth } from '../helpers/context';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { resolvePhonePrefix, trimPhone } from '../helpers';

export default function SendWhatsAppMsg({ dialog, setDialog }) {
    const [isSendingWhatsAppMsg, setIsSendingWhatsAppMsg] = useState(false);
    const [errors, setErrors] = useState(false);
    const [selectedNumbers, setSelectedNumbers] = useState([]);
    const { token, vendor } = useAuth();
    const [number, setNumber] = useState('');
    // const [checkingWhatsAppLink, setCheckingWhatsAppLink] = useState(0);
    const history = useNavigate();
    const { t, i18n } = useTranslation();
    const [whatsConnectionType, setWhatsConnectionType] = useState(-1);

    useEffect(() => {
        if (dialog.visible) {
            getWLProfile({ userName: vendor, language: i18n.language === 'ar' ? '0' : '1' }).then((_userInfo) => {
                if (_userInfo.resCode === 0) {
                    setNumber(_userInfo.response.wlUser.whatsapp);
                    setWhatsConnectionType(_userInfo.response.wlUser.whatsType || 0)

                    // connectWithWhatsApp({ userId: token, language: i18n.language === 'ar' ? '0' : '1' }).then(res => {
                    //     if (res.resCode === 0) {
                    //         if (res.response.message === 'Already logged in')
                    //             setCheckingWhatsAppLink(1);
                    //         else
                    //             setCheckingWhatsAppLink(2);
                    //     } else {
                    //         // toast.error(res.resStr);
                    //         setCheckingWhatsAppLink(3);
                    //     }
                    // });
                }
            });
            setSelectedNumbers(dialog.numbers);
        }
    }, // eslint-disable-next-line
        [dialog.visible]);
    
        function delay(t, data) {
            return new Promise(resolve => {
                setTimeout(resolve, t, data);
            });
    }
    
        async function runSequence(array, delayT, fn) {
            for (let item of array) {
                await fn(item);
                await delay(delayT);
            }
            return null;
        }
    
    
    const sendMessage = () => {
        setIsSendingWhatsAppMsg(true);
        if (whatsConnectionType === 1) {
            runSequence(selectedNumbers.map(item => resolvePhonePrefix(item)), 2000, (item) => {
                sendAmakknWhatsAppMessage({
                    userId: token,
                    data: {
                        "messaging_product": "whatsapp",
                        "to": item, //966537075733
                        "type": "template",
                        "template": {
                          "name": "oneproperty",
                          "language": {
                            "code": "ar"
                          },
                          "components": [
                            {
                              "type": "header",
                              "parameters": [
                                {
                                  "type": "image",
                                  "image": {
                                    "link": dialog?.property?.photos?.split(',')?.[0] || `https://www.amakkn.com/assets/img/defimgs/${dialog?.property?.propertyType || '1'}.png`
                                  }
                                }
                              ]
                            },
                            {
                              "type": "body",
                              "parameters": [
                                {
                                  "type": "text",
                                  "text": dialog.message?.replace(/\n/g,' ')
                                },
                        {
                                  "type": "text",
                                  "text": " "
                                }
                              ]
                            },
                            {
                              "type": "button",
                              "sub_type": "url",
                              "index": 0,
                              "parameters": [
                                {
                                  "type": "text",
                                  "text": `property-details/${dialog?.property?.idToShare}`
                                }
                              ]
                            }
                          ]
                        }
                    }
                }).then(res => {
                    if (res.resCode === 0) {
                        toast.success(t("MessageSentSuccessfully"));
                        setDialog({ visible: false, numbers: [], message: '', customers: [] })
                    }
                    else
                        toast.error(res.resStr);
                
                }).finally(() => setIsSendingWhatsAppMsg(false));
            }).then(() => {
                setIsSendingWhatsAppMsg(false);
                toast.success(t("MessageSentSuccessfully"));
            }).catch(() => setIsSendingWhatsAppMsg(false));
           
        } else {
            sendWhatsAppMessage({
                userId: token,
                number: resolvePhonePrefix(number),
                to: selectedNumbers.map(item => resolvePhonePrefix(item)),
                message: dialog.message
            }).then(res => {
                if (res.resCode === 0) {
                    toast.success(t("MessageSentSuccessfully"));
                    setDialog({ visible: false, numbers: [], message: '', customers: [] })
                }
                else
                    toast.error(res.resStr);
                
            }).finally(() => setIsSendingWhatsAppMsg(false));
        }
      
    }
    
    return (
        <Dialog
            fullWidth={true}
            maxWidth={dialog.multiple ? "md" : 'xs'}
            open={dialog.visible}
            className="custom-dialog model "
            onClose={() => {
                setDialog({ visible: false, numbers: [], message: '', customers: [] });
                // setCheckingWhatsAppLink(0);
                setWhatsConnectionType(-1);
            }}>
            <DialogTitle>
                <div className="dialog-head">
                    <div>
                        <h2> {dialog.multiple ? t("ContactCustomersInterestedInThisPropertyViaWhatsApp") : t("ContactTheCustomerViaWhatsApp")}</h2>
                    </div>
                    <div className="dialog-actions">
                        <span onClick={() => {
                            setDialog({ visible: false, numbers: [], message: '', customers: [] });
                            // setCheckingWhatsAppLink(0);
                            setWhatsConnectionType(-1);
                        }}
                            style={{ cursor: 'pointer' }}>
                            <Close />
                        </span>
                    </div>
                </div>
            </DialogTitle>
            <DialogContent>
                <Grid container spacing={3}>
                    {dialog.multiple && (
                        <Grid item xs={12} lg={7}>
                            <Divider textAlign="left" className="mt-2 mb-3 p-0" style={{ color: 'var(--main-color-one)' }}  >
                                {t("CustomersPhoneNumbers")}
                            </Divider>
                          
                            <FormGroup>
                                {dialog.customers.map((item, index) => (
                                    <FormControlLabel key={index} control={<Checkbox checked={selectedNumbers.includes(item.phone)} onChange={(event) => {
                                        if (event.target.checked) {
                                            setSelectedNumbers((old) => [...old, item.phone]);
                                        } else {
                                            let temp = selectedNumbers.filter(i => i !== item.phone);
                                            setSelectedNumbers(temp);
                                        }
                                    }} />} label={item.name + ', ' + trimPhone(item.phone)} />
                                ))}
                            </FormGroup>
                            <FormHelperText>
                                {errors && dialog.numbers.length === 0 ?
                                    <Alert severity="error" style={{ width: 'fit-content' }} className="custom-alert">
                                        {t("PleaseSelectAtLeastOneNumber")}
                                    </Alert>
                                    : ''
                                }
                            </FormHelperText>
                        </Grid>
                    )}
                 
                    <Grid item xs={12} lg={dialog.multiple ? 5 : 12}>
                        {dialog.multiple && <Divider textAlign="left" className="mt-2 mb-3 p-0" style={{ color: 'var(--main-color-one)' }}  >
                            {t("Message")}
                        </Divider>}
                        <FormControl className="my-2 w-100">
                            <TextField
                                label={t("Message")}
                                required
                                sx={{ width: "100%", direction: 'rtl' }}
                                InputLabelProps={{ shrink: true }}
                                placeholder={dialog.multiple ? t("EnterTheMessageYouWantToSendToCustomers") : t("EnterTheMessageYouWantToSendToCustomer")}
                                value={dialog.message}
                                size='small'
                                multiline
                                rows={12}
                                onChange={(e) => setDialog({ ...dialog, message: e.currentTarget.value })}
                            />
                            <FormHelperText>
                                {errors && !dialog.message ?
                                    <Alert severity="error" style={{ width: 'fit-content' }} className="custom-alert">
                                        {t("ThisFieldIsMandatory")}
                                    </Alert>
                                    : ''
                                }
                            </FormHelperText>
                        </FormControl>
                    </Grid>
                        
                </Grid>
            </DialogContent>
            <DialogActions>
                <div className='w-100 d-flex align-items-center justify-content-between flex-column flex-sm-row' style={{ gap: '10px', paddingInline: '14px' }}>
                    {whatsConnectionType===-1 ? <p>{t("ServiceIsBeingVerified")}</p> : whatsConnectionType === 0 ? (
                        <Alert
                            sx={{ "& .MuiAlert-message": { width: "100%" } }}
                            severity='error'
                            className='custom-alert align-items-center'
                            >
                            <div className='d-flex justify-content-between align-items-sm-center flex-column flex-sm-row'>
                                <span>
                                    {t("WhatsAppHasNotBeenLinked")}
                                </span>
                                <Button
                                    style={{
                                        width: "fit-content",
                                        borderColor: "#222",
                                        color: "#222",
                                    }}
                                    className='mt-2 mt-md-0 mr-3'
                                    variant='outlined'
                                    onClick={() => history('/admin/addons')}>
                                    {t("LinkNow")}
                                </Button>
                            </div>
                        </Alert>
                    ) : whatsConnectionType === 1 ? <p>{t("SuccessfullyLinkedWithTheAmakknNumber")}</p> : <p>{t("SuccessfullyLinkedWithTheCustomNumber")}</p>}
               
                    <LoadingButton
                        classes='btn primary-btn px-4'
                        OKdisabled={whatsConnectionType !== 1 && whatsConnectionType !== 2}
                        loading={isSendingWhatsAppMsg}
                        handleClick={(e) => {
                            if (dialog.message === "" || dialog.numbers.length === 0) {
                                setErrors(true);
                            }
                            else
                                sendMessage();
                        }}
                        label={t("Send")}
                    />
                </div>
              
            </DialogActions>
        </Dialog>
    );
}